export class Contato {
    nome: string;
    sobrenome: string;
    dataNascimento: Date;
    sexo: string;
    email: string;
    validado: boolean = false;
}